import { css } from 'linaria';

export const linkHoverStyle = css`
  :hover,
  :active {
    text-decoration: underline;
  }
`;
